import { createSelector } from 'reselect';

const teamMembersFull = state => state.teamMembersFullReducer;
const userProgramsFull = state => state.userProgramsFullReducer;
const modules = state => state.modulesListReducer;
const content = state => state.contentListReducer;
const versions = state => state.savedVersionsReducer;
export const messageList = state => state.messagesListReducer;

export const getUserPrograms = createSelector(
  userProgramsFull, 
  programsFull => { 
    
    return (programsFull && programsFull.programs !== null) ? programsFull.programs : null
  }
  );

  export const getAssessments = createSelector(
    content, 
    assessmentsFull => { 
      
      return (assessmentsFull && assessmentsFull.assessments !== null) ? assessmentsFull.assessments : null
    }
    );

  export const getModulesPrograms = createSelector(
    modules, 
    modulesFull => { 
      
      return (modulesFull && modulesFull.modules !== null) ? modulesFull.modules : null
    }
    );

  export const getTools = createSelector(
    content, 
    tools => { 
      
      return (tools && tools.tools !== null) ? tools.tools : null
    }
  );
  export const getSessions = createSelector(
    content, 
    sessions => { 
      
      return (sessions && sessions.webinar !== null) ? sessions.webinar : null
    }
  );
  export const getContentModules = createSelector(
      content, 
      contentFull => { 
        return (contentFull && contentFull.content !== null) ? contentFull.content : null
      }
      );

  export const getCurrentPrograms = createSelector(
    userProgramsFull, 
    programsFull => { 
      return Array.isArray(programsFull.programs) && programsFull.programs.filter(contentItem => contentItem.status!=='completed')
    }
    );

    export const getCompletedPrograms = createSelector(
      userProgramsFull, 
      programsFull => { 
        
        return Array.isArray(programsFull.programs) && programsFull.programs.filter(contentItem => contentItem.status=='completed')
      }
      );

export const selectedProgramId = createSelector(
  userProgramsFull,
  programs => {
    return programs.selectedProgramId !== null ? programs.selectedProgramId : null
  }
);

export const selectedProgram = createSelector(
  getUserPrograms,
  selectedProgramId,
  (programs, _selectedProgramId) => {
    
    return  (programs && Array.isArray(programs)) ? programs.find(program => program.programId === _selectedProgramId) : null
  }
   
);

export const getModulesForProgram = createSelector(
  selectedProgram, 
  program=> { 
    
    return (program && program.modules !== null) ? program.modules : null
  }
);

export const selectedModuleId = createSelector(
  userProgramsFull,
  programs => {
    return programs.selectedModuleId !== null ? programs.selectedModuleId : null
  }
);

export const selectedModule= createSelector(
  getModulesPrograms,
  selectedModuleId,
  (modules, _selectedModuleId) => {
    return  (modules && Array.isArray(modules)) ? modules.find(module => module.moduleId === _selectedModuleId) : null
  }
   
);


export const selectedContentId = createSelector(
  userProgramsFull,
  programs => {
    return programs.selectedContentId !== null ? programs.selectedContentId : null
  }
);

export const selectedContent= createSelector(
  getContentModules,
  selectedContentId,
  (content, _selectedContentId) => {
    return  (content && Array.isArray(content)) ? content.find(content => content.contentId === _selectedContentId) : null
  }
   
);
export const getAllModules = createSelector(
  getUserPrograms,
    programs =>
      Array.isArray(programs) && programs.reduce((acc, curr) => [...acc, ...curr.modules], []),
  );

export const getAllContent = createSelector(
    getAllModules,
    module => Array.isArray(module) && module.reduce((acc, curr) => [...acc, ...curr.content], []),
  );

export const getAllThinkTools = createSelector(
    getTools,
    content => {
      
      return Array.isArray(content) && content.filter(contentItem => contentItem.type === 'ThinkTool')
    }
      
  );

  export const getCurrentTools = createSelector(
    getAllThinkTools, 
    programsFull => { 
      
      return Array.isArray(programsFull) && programsFull.filter(contentItem => contentItem.status!=='completed')
    }
    );

    export const getCompletedTools = createSelector(
      getAllThinkTools, 
      programsFull => { 
        return Array.isArray(programsFull) && programsFull.filter(contentItem => contentItem.status=='completed')
      }
      );
  

  export const getAllThinkToolsAndJournals = createSelector(
      getContentModules,
      content =>
        Array.isArray(content) && content.filter(contentItem => contentItem.type === 'ThinkTool' || contentItem.type === 'Journal') ,
    );

  export const getAllAssignmentsCurrent = createSelector(
    getAssessments,
    selectedProgramId,
    (content, _selectedProgramId) =>
      Array.isArray(content) && content.filter(contentItem =>  (contentItem.type === 'Assignments' || contentItem.type === 'WSR Assessments' || contentItem.type === 'Assessment Builder' || contentItem.type === 'Exam Builder')  && (contentItem.status!='completed')),
  );

  export const getAllAssignmentsCompleted= createSelector(
    getAssessments,
    selectedProgramId,
    (content, _selectedProgramId) =>
      Array.isArray(content) && content.filter(contentItem =>  (contentItem.type === 'Assignments' || contentItem.type === 'WSR Assessments' || contentItem.type === 'Assessment Builder' || contentItem.type === 'Exam Builder') && (contentItem.status=='completed')),
  );

export const getAllToolsCurrent = createSelector(
    getAllThinkTools,
    selectedProgramId,
    (content, _selectedProgramId) =>
      Array.isArray(content) && content.filter(contentItem => contentItem.program_id === _selectedProgramId && (contentItem.status!=='completed')),
  );
  export const getAllToolsCompleted = createSelector(
    getAllThinkTools,
    selectedProgramId,
    (content, _selectedProgramId) =>
      Array.isArray(content) && content.filter(contentItem => contentItem.program_id === _selectedProgramId && (contentItem.status=='completed')),
  );

  export const getAllSessionsCurrent = createSelector(
    getSessions,
    (content) =>
      Array.isArray(content) && content.filter(contentItem => (contentItem.status!=='completed')),
  );
  export const getAllSessionsCompleted = createSelector(
    getSessions,
    (content) =>
      Array.isArray(content) && content.filter(contentItem => (contentItem.status=='completed')),
  );

export const getVersions = createSelector(
      versions, 
      version => { 
        
        return (version && version.learnerVersions !== null) ? version.learnerVersions : null
      }
);

export const getVersionsStatus = createSelector(
  getVersions, 
  version => {
    return Array.isArray(version) && version.filter(contentItem => (contentItem.status=='pending'))
  }
);

export const getVersionsStatusCard = createSelector(
  getVersions, 
  version => {
    return Array.isArray(version) && version[0]
  }
);
export const selectedVersionId = createSelector(
  userProgramsFull,
  programs => {
    
    return programs.selectedUserVersion !== null ? programs.selectedUserVersion : null
  }
);

export const selectedFilter = createSelector(
  userProgramsFull,
  programs => {
    return programs.filter !== null ? programs.filter : null
  }
);

export const getFilteredComponents= createSelector(
  getContentModules,
  selectedFilter,
  (content, filter) => {
    
   if( filter[0]=='All'){
    return Array.isArray(content) && content
   }
    return Array.isArray(content) && content.filter(contentItem => contentItem.type === filter[0])


  }
);

export const selectedVersion= createSelector(
  getVersions,
  selectedVersionId,
  (version, _selectedVersionId) => {
   
    return  (version && Array.isArray(version)) ? version.find(version => version.versionId === _selectedVersionId) : null
  }
   
);

export const getSelectedThinktool = createSelector(
    getAllThinkTools,
    getContentModules,
    selectedContentId,
    (thinktools, content, _selectedContentId) => {
     if(thinktools.length==0){
      return Array.isArray(content) && content.find(contentItem => contentItem.contentId === _selectedContentId)
     }else{
      return Array.isArray(thinktools) && thinktools.find(contentItem => contentItem.contentId === _selectedContentId)
     }
      
    }
     
  );
////
export const getUsersMessageList = createSelector(
    messageList,
    messages => (Array.isArray(messages.list) ? messages.list : []),
  );

  export const getUsersMessageSent = createSelector(
    messageList,
    messages => (Array.isArray(messages.sentlist) ? messages.sentlist : []),
  );

